<script lang="ts" generics="T extends string | number">
  import type { Component } from 'svelte';
  interface Option { value: T; label: string; icon?: Component<any> }
  interface Props {
    value: T;
    options: Option[];
    size?: 'sm' | 'md';
    full?: boolean;
    onchange?: (value: T) => void;
    ariaLabel?: string;
  }
  let { value = $bindable(), options, size = 'md', full = false, onchange, ariaLabel }: Props = $props();
</script>

<div class="seg {size}" class:full role="radiogroup" aria-label={ariaLabel}>
  {#each options as option (option.value)}
    <button
      type="button"
      role="radio"
      aria-checked={value === option.value}
      class:active={value === option.value}
      onclick={() => {
        value = option.value;
        onchange?.(option.value);
      }}
    >
      {#if option.icon}<option.icon size={15} />{/if}
      <span>{option.label}</span>
    </button>
  {/each}
</div>

<style>
  .seg {
    display: inline-flex;
    padding: 3px;
    gap: var(--space-0_5);
    background: var(--surface-3);
    border-radius: var(--radius-button);
    border: 1px solid var(--border);
    max-width: 100%;
    overflow-x: auto;
  }
  .seg.full { display: flex; width: 100%; }
  .seg.full button { flex: 1; }
  button {
    display: inline-flex; align-items: center; justify-content: center; gap: var(--space-1_5);
    height: calc(var(--control-h) - 8px);
    padding: 0 var(--space-3);
    border: 0;
    border-radius: var(--radius-button);
    background: transparent;
    color: var(--text-2);
    font-size: var(--text-sm);
    font-weight: var(--weight-semibold);
    white-space: nowrap;
    transition: background var(--dur), color var(--dur), box-shadow var(--dur);
  }
  .sm button { height: calc(var(--control-h-sm) - 6px); padding: 0 var(--space-2_5); font-size: var(--text-xs); }
  button:hover { color: var(--text); }
  button:focus-visible { outline: none; box-shadow: var(--ring); }
  button.active { background: var(--surface); color: var(--brand); box-shadow: var(--shadow-sm); }
</style>
